import {ShiftType} from '../validation/schemas/RequestScheduleSchema';

const dayMap: Record<string, string> = {
	monday: 'SEGUNDA',
	tuesday: 'TERCA',
	wednesday: 'QUARTA',
	thursday: 'QUINTA',
	friday: 'SEXTA',
	saturday: 'SABADO',
	sunday: 'DOMINGO',
};

export const processShift = (shift?: ShiftType) => {
	if (!shift || !shift.active || !shift.days) return [];
	return Object.entries(shift.days)
		.filter(([, isActive]) => isActive)
		.map(([day]) => dayMap[day]);
};
